<template>
  <div>
    <Header />
    <Slider />

    <div class="my-2 services" style="direction: ltr !important;">
      <div class="container">
        <div style="color: #4d4d4d" class="fw-bold d-block text-start">خدمات</div>

        <div dir="rtl">
          <swiper :slides-per-view="3" :space-between="20" :navigation="true">
            <swiper-slide>
              <div class="service-item text-center">
                <router-link :to="{ name: 'newLoads' }">
                  <img class="bg-white rounded shadow service-img" src="assets/svg/barlist.svg" alt="" />
                </router-link>
                <p class="mt-1">لیست بارها</p>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="service-item text-center">
                <router-link :to="{ name: 'myCargos' }">
                  <img class="bg-white rounded shadow service-img" src="assets/svg/barHistory.svg" alt="" />
                </router-link>
                <p class="mt-1">تاریخچه بارها</p>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="service-item text-center">
                <router-link :to="{ name: 'profile' }">
                  <img class="bg-white rounded shadow service-img" src="assets/svg/Profile.svg" alt="" />
                </router-link>
                <p class="mt-1">حساب کاربری</p>
              </div>
            </swiper-slide>
            <div v-if="this.screenHeight < 715">
              <swiper-slide v-for="(service, index) in services" :key="index">
                <div class="service-item text-center">
                  <a :href="service.link">
                    <img class="bg-white rounded shadow service-img" :src="baseURL + service.icon"
                      :alt="service.title" />
                  </a>
                  <p class="mt-1">{{ service.title }}</p>
                </div>
              </swiper-slide>
            </div>
          </swiper>

          <!-- خدمات دینامیک: اسلایدر یا گرید -->
          <div v-if="services && services.length > 0 && this.screenHeight >= 715" class="my-2">
            <!-- اگر بیش از ۴ آیتم -->
            <swiper v-if="services.length > 3" :slides-per-view="3" :space-between="20" :navigation="true">
              <swiper-slide v-for="(service, index) in services" :key="index">
                <div class="service-item text-center">
                  <a :href="service.link">
                    <img class="bg-white rounded shadow service-img" :src="baseURL + service.icon"
                      :alt="service.title" />
                  </a>
                  <p class="mt-1">{{ service.title }}</p>
                </div>
              </swiper-slide>
            </swiper>

            <!-- اگر ۴ یا کمتر -->
            <div v-else class="row row-cols-3 text-center justify-content-center">
              <div v-for="(service, index) in services" :key="index" class="col service-item">
                <a :href="service.link">
                  <img class="bg-white rounded shadow service-img" :src="baseURL + service.icon" :alt="service.title" />
                </a>
                <p class="mt-1">{{ service.title }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Frequently used services -->
        <div class="position-absolute-bottom">
          <div dir="ltr">
            <div class="fw-bold text-start mx-2">خدمات پرکاربرد
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="gold" viewBox="0 0 24 24">
                <path
                  d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.879 1.504 8.293L12 18.896l-7.44 4.582 1.504-8.293L0 9.306l8.332-1.151z" />
              </svg>
            </div>
            <div class="card pt-2 m-2 frequently">
              <div class="row justify-content-center">
                <div class="col-4">
                  <div class="row gap-2 justify-content-between w-auto">
                    <div @click="searchProvince()"
                      class="col service-item gap-2 d-flex flex-column align-items-center fw-bold">
                      <img class="bg-white rounded shadow service-img" src="assets/svg/Search.svg" alt="search" />
                      <p>جستجوی استانی</p>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div @click="nearLoads()"
                    class="col service-item gap-2 d-flex flex-column align-items-center fw-bold">
                    <img class="bg-white rounded shadow service-img" src="assets/svg/Location.svg" alt="location" />
                    <p>بارهای اطراف من</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Slider from '@/components/Slider.vue'
import Header from '@/components/HeaderHome.vue'
import router from '@/router'
import axios from 'axios'
import Swal from 'sweetalert2'

// Swiper
import { Swiper, SwiperSlide } from 'swiper/vue'
// import 'swiper/css'
// import 'swiper/css/navigation'
import SwiperCore, { Navigation } from 'swiper'
SwiperCore.use([Navigation])

export default {
  name: 'home',
  components: {
    Slider,
    Header,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      axiosConfig: {
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      },
      services: [],
      baseURL: 'https://dashboard.iran-tarabar.ir/',
      screenHeight: window.innerHeight,
    };
  },
  methods: {
    nearLoads() {
      router.push({ name: 'nearLoads' })
    },
    updateScreenHeight() {
      this.screenHeight = window.innerHeight;
    },
    searchProvince() {
      router.push({ name: 'selectCities' })
    },
    getServices() {
      axios.get("https://core.iran-tarabar.ir/api/services", this.axiosConfig)
        .then((response) => {
          this.services = response.data.services
        })
        .catch(error => {
          console.error("خطا در گرفتن سرویس‌ها:", error)
        });
    },
    tokenHandle() {
      if (this.$route.query.token) {
        axios.patch(`https://core.iran-tarabar.ir/api/driver/saveMyFireBaseToken`, {
          token: this.$route.query.token,
          version: 74,
        }, this.axiosConfig).catch((error) => {
          if (error.response && error.response.status === 401) {
            Swal.fire({
              title: "راننده محترم!",
              text: "شماره ای که با آن وارد برنامه شده اید، توسط دستگاه دیگری مورد استفاده قرار گرفته است!",
              icon: "error",
              confirmButtonColor: "#068b80",
              confirmButtonText: "ورود مجدد!",
            }).then((result) => {
              if (result.isConfirmed) {
                localStorage.clear();
                router.push({ name: 'login' })
              }
            });
          }
        });
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateScreenHeight);
  },
  computed: {
    dynamicStyle() {
      return this.screenHeight < 715
        ? { overflowX: "scroll", height: "110px" }
        : {};
    },
  },
  mounted() {
    window.addEventListener("resize", this.updateScreenHeight);
    localStorage.removeItem('scrollPosition');
    this.getServices();
    this.tokenHandle();
  }
}
</script>

<style scoped>
.position-absolute-bottom {
  position: absolute;
  bottom: 7rem;
  right: 0px;
  left: 0px;
}

p {
  font-size: 13px;
}

.service-item {
  font-weight: 500;
}

.service-img {
  width: 56px;
}

main {
  min-height: 630px;
}
</style>
